/**
 * @fileoverview CookieBanner.jsx
 * 
 * © 2026 KITH Travels (Pvt) Ltd. All rights reserved.
 * This software is the confidential and proprietary information of KITH Travels.
 * You shall not disclose such Confidential Information and shall use it only in 
 * accordance with the terms of the license agreement you entered into with KITH Travels.
 */
import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const consent = localStorage.getItem('kith_cookie_consent')
    if (!consent) {
      setIsVisible(true)
    }
  }, [])

  const handleAcceptAll = () => {
    localStorage.setItem('kith_cookie_consent', 'all')
    setIsVisible(false)
  }

  const handleNecessaryOnly = () => {
    localStorage.setItem('kith_cookie_consent', 'necessary')
    setIsVisible(false)
  }

  if (!isVisible) return null

  return (
    <div className="fixed bottom-6 left-4 right-4 md:left-6 md:right-auto md:w-[40%] bg-white/60 backdrop-blur-xl rounded-xl z-[100] border-2 border-KITH-primary/10 p-6 animate-fade-in-up">
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-KITH-primary/10 flex items-center justify-center text-KITH-primary">
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4" />
            </svg>
          </div>
          <strong className="text-gray-900 font-bold text-lg">Your Privacy</strong>
        </div>
        
        <p className="text-sm text-gray-600 leading-relaxed text-left">
          We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. Read our <Link to="/cookie-policy" className="text-KITH-primary hover:underline font-semibold">Cookie Policy</Link>.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3 mt-2 w-full">
          <button 
            onClick={handleNecessaryOnly}
            className="flex-1 py-2.5 text-sm font-semibold text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-xl transition-colors text-center"
          >
            Strictly Necessary
          </button>
          <button 
            onClick={handleAcceptAll}
            className="flex-1 py-2.5 text-sm font-semibold text-white bg-KITH-primary hover:bg-KITH-secondary rounded-xl transition-colors text-center shadow-lg shadow-KITH-primary/30"
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  )
}
